/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $(document).ready(function() {
          var winHeight = $(window).height();
          console.log(winHeight);
          $('.mobile-menu .mobile-menu-list').css('height', winHeight);
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $(document).ready(function() {
          $('.js-toggle-menu').click(function(e){
            e.preventDefault();
            $(this).toggleClass('open');
            $('.mobile-menu-main').toggleClass('menu-open');
            $('.bottom-header').toggleClass('list-open');
            $('body').toggleClass('over-flow-hidden');

			if($('body').hasClass()){

            $('.banner-slider, .tab-slider, .tab-slider-bottom').slick('slickPlay');

			} else {

            $('.banner-slider, .tab-slider, .tab-slider-bottom').slick('slickPause');


			}
          });
        });
        //Slider
        $(document).ready(function(){
          $('.banner-slider').slick({
            infinite: true,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1
          });
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        //Home Tabs
        $(document).ready(function() {

          (function ($) {
            $('.tab ul.tabs').addClass('active').find('> li:eq(0)').addClass('current');

            $('.tab ul.tabs li a').click(function (g) {
              var tab = $(this).closest('.tab'),
                index = $(this).closest('li').index();

              tab.find('ul.tabs > li').removeClass('current');
              $(this).closest('li').addClass('current');

              tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').slideUp();
              tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').slideDown();

              g.preventDefault();
            } );
          })(jQuery);

        });

        //Slider
        $(document).ready(function(){
          $('.tab-slider').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            focusOnSelect: true,
            asNavFor: '.tab-slider-bottom',
            responsive: [
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  autoplay: true,
                  autoplaySpeed: 5000
                }
              }
            ]
          });
        });

        $(document).ready(function(){
          $('.tab-slider-bottom').slick({
            infinite: true,
            slidesToShow: 1,
            arrows: false,
            slidesToScroll: 1,
            asNavFor: '.tab-slider'
          });
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
